import React from 'react';
import { COLOR, FONT } from './tokens';

// Top-level page wrapper. Sits inside App.js's <div className="container">
// (which is what the sidebar shifts). Owns the page background, base font,
// and horizontal containment so children don't leak past the viewport.

const wrap = {
  color: COLOR.ink,
  fontFamily: FONT,
  minWidth: 0,
  maxWidth: '100%',
  boxSizing: 'border-box',
};

const inner = {
  padding: '8px 4px 40px',
};

export default function Page({ children, style }) {
  return (
    <div style={{ ...wrap, ...style }}>
      <div style={inner}>{children}</div>
    </div>
  );
}
